import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ExamInstructions() {
  const navigate = useNavigate();

  useEffect(() => {
    const stored = localStorage.getItem('selectedExam');
    if (stored) {
      // The examInfo state was previously set here, but it's no longer used.
    }
  }, []);

  const instructions = [
    {
      icon: 'ri-file-list-3-line',
      title: '問題数',
      description: '全50問の三択問題です'
    },
    {
      icon: 'ri-time-line',
      title: '試験時間',
      description: '時間制限はありません。ゆっくりお考えください'
    },
    {
      icon: 'ri-checkbox-circle-line',
      title: '合格基準',
      description: '70点以上で合格となります'
    },
    {
      icon: 'ri-arrow-left-right-line',
      title: '問題の移動',
      description: '前後の問題に自由に移動できます'
    },
    {
      icon: 'ri-refresh-line',
      title: '再受験',
      description: '不合格の際の再試験は、事務局にお問合せください'
    }
  ];

  return (
    <div className="min-h-screen bg-[#F5F5F5]">
      <div className="max-w-md mx-auto px-4 py-6">
        <div className="mb-6">
          <button
            onClick={() => navigate('/select-exam')}
            className="flex items-center gap-2 text-gray-500 hover:text-gray-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
            <span className="font-bold">資格選択に戻る</span>
          </button>
        </div>

        <div className="bg-white rounded-3xl shadow-sm p-6 mb-6">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-100 rounded-full mb-4">
              <i className="ri-information-line text-orange-500 text-3xl"></i>
            </div>
            <h1 className="text-xl font-bold text-gray-800 mb-2">受験前の注意事項</h1>
            <p className="text-sm text-gray-500">試験を開始する前に、以下の内容をご確認ください</p>
          </div>

          <div className="space-y-4 mb-8">
            {instructions.map((item, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-4 bg-gray-50 rounded-2xl"
              >
                <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center flex-shrink-0 shadow-sm text-orange-500">
                  <i className={`${item.icon} text - xl`}></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-800 mb-1 text-sm">{item.title}</h3>
                  <p className="text-xs text-gray-600 leading-relaxed">{item.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-orange-50 rounded-2xl p-5 mb-8">
            <div className="flex items-start gap-3">
              <i className="ri-alert-line text-orange-500 text-xl shrink-0 mt-0.5"></i>
              <div>
                <h3 className="font-bold text-gray-800 mb-2 text-sm">重要事項</h3>
                <ul className="space-y-2 text-xs text-gray-600">
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-orange-400 mt-0.5 flex-shrink-0"></i>
                    <span>試験中はブラウザを閉じないでください</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-orange-400 mt-0.5 flex-shrink-0"></i>
                    <span>全ての問題に回答してから結果を確認できます</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-orange-400 mt-0.5 flex-shrink-0"></i>
                    <span>落ち着いて、じっくりと問題に取り組んでください</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <button
            onClick={() => navigate('/exam')}
            className="w-full bg-[#F4B183] text-white py-4 rounded-xl font-bold hover:bg-[#E5A072] transition-colors shadow-sm flex items-center justify-center gap-2"
          >
            試験を開始する
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
